// Two stacked canvases (spec §5.1): static objects below, interactive UI and
// in-flight objects above. Backing stores track devicePixelRatio.

export class Layers {
  readonly staticCanvas: HTMLCanvasElement;
  readonly interactiveCanvas: HTMLCanvasElement;
  readonly staticCtx: CanvasRenderingContext2D;
  readonly interactiveCtx: CanvasRenderingContext2D;
  /** CSS pixel size of the viewport. */
  width = 0;
  height = 0;
  dpr = 1;
  onResize: () => void = () => {};

  private readonly container: HTMLElement;
  private dprQuery: MediaQueryList | null = null;

  constructor(container: HTMLElement) {
    this.container = container;
    this.staticCanvas = document.createElement('canvas');
    this.interactiveCanvas = document.createElement('canvas');
    this.staticCanvas.className = 'layer layer-static';
    this.interactiveCanvas.className = 'layer layer-interactive';
    container.append(this.staticCanvas, this.interactiveCanvas);
    this.staticCtx = this.staticCanvas.getContext('2d', { alpha: false })!;
    this.interactiveCtx = this.interactiveCanvas.getContext('2d')!;

    new ResizeObserver(() => this.resize()).observe(container);
    this.watchDpr();
    this.resize();
  }

  private watchDpr(): void {
    this.dprQuery?.removeEventListener('change', this.onDprChange);
    this.dprQuery = matchMedia(`(resolution: ${devicePixelRatio}dppx)`);
    this.dprQuery.addEventListener('change', this.onDprChange);
  }

  private onDprChange = (): void => {
    this.watchDpr();
    this.resize();
  };

  private resize(): void {
    const { width, height } = this.container.getBoundingClientRect();
    const dpr = devicePixelRatio || 1;
    if (width === this.width && height === this.height && dpr === this.dpr) return;
    this.width = width;
    this.height = height;
    this.dpr = dpr;
    for (const c of [this.staticCanvas, this.interactiveCanvas]) {
      c.width = Math.round(width * dpr);
      c.height = Math.round(height * dpr);
      c.style.width = `${width}px`;
      c.style.height = `${height}px`;
    }
    this.onResize();
  }
}
